import React from "react";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
//import Table from "./Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faUndo, faPen, faMinus, faTimes, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { PopupMessage } from "../../utils/utils";
import { clientAccess, clientId } from "../../utils/index";
import apiUrl from "../../apiUrlConstant";
import SimpleReactValidator from "simple-react-validator";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class RentCharge extends React.Component {
  state = {
    popupContent: "",
    messsagePopup: false,
    redirect: false,
    id: undefined,
    initialValues: {
    },
    vendorList: [
      {
        id: 1,
        company_name: "Vendor 1",
      },
      {
        id: 2,
        company_name: "Vendor 2",
      }
    ],
    existingCharges: [{}],
    readOnly: false,
    percentageErr: "",
  };

  componentDidMount() {

    const { id } = this.props.match.params;

    axios.get(`${apiUrl.apiUrl.url}/landlord/lease-wise-list?id=${id}`)
      .then(response => {
        console.log(response);
        let data = response.data.data;

        //const vendor = data.filter(item => item.is_vendor === "yes").map(item => ({
        const vendor = data.map(item => ({
          value: item.id,
          label: item.company_name
        }));

        this.setState({
          vendorList: vendor
        });
      });

    

    axios.get(`${apiUrl.apiUrl.url}/create-lease/fetch-landlord-charges?id=` + id)
      .then(response => {
        const list = response.data.list;
        const landlordDetails = [
          Object.keys(list).reduce((acc, key) => {
            acc[key] = list[key].map((item) => ({
              landlord_id: item.landlord_id,
              percent: parseFloat(item.percentage).toString(),
            }));
            return acc;
          }, {}),
        ];

        this.setState({
          existingCharges: landlordDetails
        });
      });

  };
  
  redirectAfterSave = () => {
    this.setState({
        redirect: true,
        messsagePopup: false,
        delete: false,
        popupContent: "",
        initialValues: {
            tenant: '',
            contacts: []
        },
    });
};

  componentDidUpdate() {
  }

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  

  render() {
    const { id } = this.props.match.params;
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to={`/createlease/submit-lease/${id}`} />;
    }

    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li>
                <FontAwesomeIcon icon={faChevronRight} />
              </li>
              <li>
                <Link to="/masters/client-directory">Create Lease</Link>
              </li>
              <li>
                <FontAwesomeIcon icon={faChevronRight} />
              </li>
              <li>
                <Link to="/#">Landlord Charge</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="parentContainer">
          {this.renderForm()}
        </div>
      </>
    );
  }


  renderForm() {

    const tabList = [
      {
        label: "CAM",
        value: "cam",
      },
      {
        label: "RENT",
        value: "rent",
      },
      // {
      //   label: "Other Rent Details",
      //   value: "other rent details",
      // },
      {
        label: "Property Tax",
        value: "property tax",
      },
      {
        label: "Marketing Fund",
        value: "marketing fund",
      },
      {
        label: "Parking 2W",
        value: "parking 2w",
      },
      {
        label: "Parking 4W",
        value: "parking 4w",
      },
      {
        label: "Parking Other",
        value: "parking other",
      },
      {
        label: "Storage",
        value: "storage",
      },
      {
        label: "Signage",
        value: "signage",
      },
    ];

    return (
      <>
        <div className="brandDetailFormWithTabs">
          <Formik
            enableReinitialize={true}
            initialValues={{
              landlordDetails: this.state.existingCharges
            }}
            onSubmit={(values) => {
              const { id } = this.props.match.params;
              var self = this;
              axios({
                  method: "post",
                  url: apiUrl.apiUrl.url+'/create-lease/add-landlord-charges?id=' + id,
                  data: values,
              }).then(function (response) {

                  if (response.data.status == 'success') {
                      
                      self.setState({
                          messsagePopup: true,
                          popupContent: "Detail Saved Successfully!",
                          url: `${apiUrl.apiUrl.url}/createlease/submit-lease/${id}`
                      });

                  } else {
                      //self.state.percentageErr =response.data.message;
                      self.state.percentageErr ='Please select the landlord and provide the respective percentage.';
                      self.setState({});
                  }
              });

            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (
              <Form autoComplete="off" >
                <Tabs className="brandDesignTabs">
                  <TabList>
                    {tabList.map((tabItem, index) => (
                      <Tab key={index} label={tabItem.label} value={tabItem.value} onClick={() => this.setState({ percentageErr: '' })} >{tabItem.label}</Tab>
                    ))}
                  </TabList>

                  {tabList.map((tabItem, index) => {
                    return (
                      <TabPanel key={index}>
                        <div className={`tabPanelInner${tabItem.value} tabPanelInner`}>
                          <FieldArray
                            name={`landlordDetails[0].${tabItem.value}`}
                            render={(arrayHelpers) => (
                              <div className="d-grid gap-3">
                                {values.landlordDetails[0][tabItem.value] && values.landlordDetails[0][tabItem.value].length > 0 ? (
                                  values.landlordDetails[0][tabItem.value].map((item, idx) => (
                                    <div key={idx}>
                                      <div className="row m-0 paidToParent align-items-center">
                                        <div className="col-3 p-0">
                                          <p className={idx === 0 ? "d-block" : "d-none"}>Landlord Details</p>
                                        </div>
                                        <div className="col-6">
                                          <div className="d-flex gap-4 align-items-center">
                                            <Select
                                              className="w-100 bgClrNew"
                                              classNamePrefix="bgClrNewInner"
                                              options={this.state.vendorList}
                                              name={`landlordDetails[0].${tabItem.value}[${idx}].landlord_id`}
                                              value={this.state.vendorList.find(option => option.value === item.landlord_id) || null}
                                              placeholder="Select a landlord"
                                              onChange={(selectedOption) => {
                                                this.setState({percentageErr : ""});
                                                arrayHelpers.replace(idx, {
                                                  ...item,
                                                  landlord_id: selectedOption?.value || '',
                                                });
                                              }}
                                            />
                                            <Field
                                              type="text"
                                              name={`landlordDetails[0].${tabItem.value}[${idx}].percent`}
                                              placeholder="Add percentage"
                                              onInput={(e) => {
                                                // Only allow numbers and a single dot
                                                e.target.value = e.target.value.replace(/[^0-9.]/g, ''); 
                                            
                                                // Restrict to valid percentage format (0-100 with up to 2 decimals)
                                                const validPercentageRegex = /^(\d{1,2}(\.\d{0,2})?|100(\.0{0,2})?)$/;
                                                if (!validPercentageRegex.test(e.target.value) && e.target.value !== '') {
                                                  e.target.value = e.target.value.slice(0, -1); // Remove last invalid character
                                                }
                                              }}
                                              onChange={(e) => {
                                                this.setState({ percentageErr: "" }); // Clear error initially
                                                const newValue = parseFloat(e.target.value) || 0;
                                              
                                                // Safely access values.landlordDetails[0][tabItem.value]
                                                const landlordDetails =
                                                  values.landlordDetails && values.landlordDetails[0]
                                                    ? values.landlordDetails[0][tabItem.value] || []
                                                    : [];
                                              
                                                const otherValues = landlordDetails.reduce((sum, val, i) => {
                                                  // Exclude the current index value
                                                  if (i !== idx) {
                                                    return sum + (parseFloat(val.percent) || 0);
                                                  }
                                                  return sum;
                                                }, 0);
                                              
                                                // Check if cumulative value exceeds 100
                                                if (newValue + otherValues <= 100) {
                                                  handleChange(e); // Update Formik state
                                                } else {
                                                  this.setState({
                                                    percentageErr: "Cumulative percentage cannot exceed 100. Please adjust."
                                                  });
                                                }
                                              }}

                                            />
                                          </div>
                                        </div>
                                        <div className="col-3 p-0">
                                          <div className="d-flex gap-3 align-items-center justify-content-start">
                                            {idx > 0 && (
                                              <button
                                                type="button"
                                                className="addBtn delBtn"
                                                onClick={() => arrayHelpers.remove(idx)}
                                              >
                                                <FontAwesomeIcon icon={faTrash} /> Delete
                                              </button>
                                            )}
                                            {idx < 1 && (
                                              <button
                                                type="button"
                                                className="addBtn"
                                                onClick={() => arrayHelpers.push({ landlord_id: '', percent: '' })}
                                              >
                                                <FontAwesomeIcon icon={faPlus} /> Add
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <>
                                    <div className="row m-0 paidToParent align-items-center">
                                      <div className="col-3 p-0">
                                        <p className={0 === 0 ? "d-block" : "d-none"}>Landlord Details</p>
                                      </div>
                                      <div className="col-6">
                                        <div className="d-flex gap-4 align-items-center">
                                          <Select
                                            className="w-100 bgClrNew"
                                            classNamePrefix="bgClrNewInner"
                                            options={this.state.vendorList}
                                            name={`landlordDetails[0].${tabItem.value}[${0}].landlord_id`}
                                            // value={paidToOptions.find(option => option.value === item.landlord_id) || null}
                                            placeholder="Select a landlord"
                                            onChange={(selectedOption) => {
                                              arrayHelpers.replace(0, {
                                                landlord_id: selectedOption?.value || '',
                                              });
                                            }}
                                          />
                                          <Field
                                            type="text"
                                            name={`landlordDetails[0].${tabItem.value}[${0}].percent`}
                                            placeholder="Add percentage"
                                            onInput={(e) => {
                                              e.target.value = e.target.value.replace(/[^0-9.]/g, ''); 
                                          
                                              // Restrict to valid percentage format (0-100 with up to 2 decimals)
                                              const validPercentageRegex = /^(\d{1,2}(\.\d{0,2})?|100(\.0{0,2})?)$/;
                                              if (!validPercentageRegex.test(e.target.value) && e.target.value !== '') {
                                                e.target.value = e.target.value.slice(0, -1); // Remove last invalid character
                                              }
                                            }}
                                            onChange={(e) => {
                                              this.setState({ percentageErr: "" }); // Clear error initially
                                              const newValue = parseFloat(e.target.value) || 0;
                                            
                                              // Safely access values.landlordDetails[0][tabItem.value]
                                              const landlordDetails =
                                                values.landlordDetails && values.landlordDetails[0]
                                                  ? values.landlordDetails[0][tabItem.value] || []
                                                  : [];
                                            
                                              const otherValues = landlordDetails.reduce((sum, val, i) => {
                                                // Exclude the current index value
                                                if (i !== 0) {
                                                  return sum + (parseFloat(val.percent) || 0);
                                                }
                                                return sum;
                                              }, 0);
                                            
                                              // Check if cumulative value exceeds 100
                                              if (newValue + otherValues <= 100) {
                                                handleChange(e); // Update Formik state
                                              } else {
                                                this.setState({
                                                  percentageErr: "Cumulative percentage cannot exceed 100. Please adjust."
                                                });
                                              }
                                            }}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-3 p-0">
                                        <div className="d-flex gap-3 align-items-center justify-content-start">
                                          {0 > 0 && (
                                            <button
                                              type="button"
                                              className="addBtn delBtn"
                                              onClick={() => arrayHelpers.remove(0)}
                                            >
                                              <FontAwesomeIcon icon={faTrash} /> Delete
                                            </button>
                                          )}
                                          {0 < 1 && (
                                            <button
                                              type="button"
                                              className="addBtn"
                                              onClick={() => arrayHelpers.push({ landlord_id: '', percent: '' })}
                                            >
                                              <FontAwesomeIcon icon={faPlus} /> Add
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    {/* <button
                                      type="button"
                                      className="addMoreBtn"
                                      onClick={() => arrayHelpers.push({ landlord_id: '', percent: '' })}
                                    >
                                      Add Landlord Info
                                    </button> */}
                                  </>
                                )}
                              </div>
                            )}
                          />
                        </div>
                      </TabPanel>
                    );
                  })}

                </Tabs>

                <div className="brandDesignTabBtn button_group mt-2 d-flex align-items-center gap-2 justify-content-between">
                  <p className="errMsg">{this.state.percentageErr}</p>
                  <button type="submit" className="add_button">Submit</button>
                </div>

              </Form>
            )}
          </Formik>
          
          <PopupMessage
                    open={this.state.messsagePopup}
                    content={this.state.popupContent}
                    redirectAfterSave={this.redirectAfterSave}
                />

        </div>
      </>
    );
  }
}

export default withRouter(RentCharge);
